/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-08 16:46:10
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-09-19 13:59:02
 */
import ButtonsCell from '@/components/tableCells/ButtonsCell';
import TextCell from '@/components/tableCells/TextCell';
import MixinCell from '@/components/tableCells/MixinCell';
import WeChatInfoCell from '@/components/tableCells/WeChatInfoCell';
import SpreadStatusCell from '@/components/tableCells/SpreadStatusCell';
import PallutInfoCell from '@/components/tableCells/PallutInfoCell';
import promoteStateCell from '@/components/tableCells/promoteStateCell';
import PallutUploadNumbCell from '@/components/tableCells/PallutUploadNumbCell';
import PallutUploadStatusCell from '@/components/tableCells/PallutUploadStatusCell';
import PallutContactInfoCell from '@/components/tableCells/PallutContactInfoCell';
import sourceCell from '@/components/tableCells/sourceCell';
import promotionCell from '@/components/tableCells/promotionCell';
import serverCell from '@/components/tableCells/serverCell';
import douKuaiCell from '@/components/tableCells/douKuaiCell';
import ImageCell from '@/components/tableCells/ImageCell';
import orderTimeCell from '@/components/tableCells/orderTimeCell';
import activityCell from '@/components/tableCells/activityCell';
import serviceRateCell from '@/components/tableCells/serviceRateCell';
import DeliveryCell from '@/components/tableCells/DeliveryCell';
import daRenCell from '@/components/tableCells/daRenCell';
import infoCell from '@/components/tableCells/infoCell';
import stateCell from '@/components/tableCells/stateCell';
import exportStateCell from '@/components/tableCells/exportStateCell';
import downloadCell from '@/components/tableCells/downloadCell';
import serviceIncomeCell from '@/components/tableCells/serviceIncomeCell';
import serviceDisburseCell from '@/components/tableCells/serviceDisburseCell';
import channelShopCell from '@/components/tableCells/channelShopCell';
import cooperationInfoCell from '@/components/tableCells/cooperationInfoCell';
import commissionRateCell from '@/components/tableCells/commissionRateCell';
import extensionTimeCell from '@/components/tableCells/extensionTimeCell';
import PartnerPerformCell from '@/components/tableCells/PartnerPerformCell';
import serverInhandCell from '@/components/tableCells/serverInhandCell';
import auditStatusCell from '@/components/tableCells/auditStatusCell';
import PartnerPerformZsCell from '@/components/tableCells/PartnerPerformZsCell';
import goodsTagCell from '@/components/tableCells/goodsTagCell';
import taskStatusCell from '@/components/tableCells/taskStatusCell';
import taskOperateCell from '@/components/tableCells/taskOperateCell';
import promotionGoodsCell from '@/components/tableCells/promotionGoodsCell';
import orderCell from '@/components/tableCells/orderCell';
import remarkCell from '@/components/tableCells/remarkCell';
import ButtonsLevelCell from '@/components/tableCells/ButtonsLevelCell';
import PriceCell from '@/components/tableCells/PriceCell';
export default {
	ButtonsCell,
	TextCell,
	MixinCell,
	WeChatInfoCell,
	SpreadStatusCell,
	PallutInfoCell,
	promoteStateCell,
	PallutUploadNumbCell,
	PallutUploadStatusCell,
	PallutContactInfoCell,
	sourceCell,
	promotionCell,
	douKuaiCell,
	ImageCell,
	serverCell,
	orderTimeCell,
	activityCell,
	serviceRateCell,
	DeliveryCell,
	daRenCell,
	infoCell,
	stateCell,
	exportStateCell,
	downloadCell,
	serviceIncomeCell,
	serviceDisburseCell,
	channelShopCell,
	cooperationInfoCell,
	commissionRateCell,
	extensionTimeCell,
	PartnerPerformCell,
	serverInhandCell,
	auditStatusCell,
	PartnerPerformZsCell,
	goodsTagCell,
	taskStatusCell,
	taskOperateCell,
	promotionGoodsCell,
	orderCell,
	remarkCell,
	PriceCell,
	ButtonsLevelCell,
};
